import { apiClient } from 'pobble-components/dist/api'
import RedirectMap from './redirects-map'

const constructApiCall = doObject => {
  switch (doObject.method) {
    case 'POST':
      return apiClient.post(doObject.url, doObject.body)
    case 'PUT':
      return apiClient.put(doObject.url, doObject.body)
    case 'PATCH':
      return apiClient.patch(doObject.url, doObject.body)
    case 'DELETE':
      return apiClient.delete(doObject.url, { data: doObject.body })
    case 'GET':
      return apiClient.get(doObject.url)
    default:
      break
  }
}

const constructRedirectLink = redirectObject => {
  const redirectMethod = RedirectMap[redirectObject.to]
  if (!redirectMethod) return null
  return redirectMethod(redirectObject.params)
}

const constructRequest = (doObject, actionName) => () => ({
  requestPrefix: 'MAGIC_LINK:ACTION',
  params: {
    body: doObject.body,
    url: doObject.url,
    type: doObject.type,
    actionName
  },
  request: () => constructApiCall(doObject)
})

export { constructRequest, constructRedirectLink }
